import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [

  {
    path: '/',
    component: () => import('@/components/Home.vue'),
    beforeEnter: (to, from, next) => {
      function isPc() {
        //判断当前入口是PC端还是APP端
        let flag =
          navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
          ) == null ? true : false
        return flag
      }

      if (window.performance.navigation.type !== 2) {
        if (isPc()) {
          next()
        } else {
          window.location.href = 'http://qgdsm.pentaq.com/'
        }
      } else {
        if (from.path !== '/') {
          window.location.href = 'https://pvp.qq.com/cp/a20220328qgds/index.shtml'
        } else {
          next()
        }
      }
    },
    meta: {
      title: '全国大赛数据平台',
      requireLogin: true,
    },
  },
  {
    path: '/sandTable-view',
    component: () => import('@/components/sandTable/SandtableEdit.vue'),
    meta: {
      title: '沙盘工具',
    },
  },
  {
    path: '/bp-view',
    component: () => import('@/components/bp/bpView.vue'),
    meta: {
      title: 'BP模拟器-准备',
    },
  },
  {
    path: '/',
    component: () => import('@/components/Root.vue'),
    meta: {
      title: '全国大赛数据平台',
    },
    children: [
      {
        path: '/bp',
        component: () => import('@/components/bp/index.vue'),
        meta: {
          title: 'BP模拟器',
        },
      },
      {
        path: '/bp-room',
        component: () => import('@/components/bp/room.vue'),
        meta: {
          title: 'BP模拟器-房间',
        },
      },
      // {
      //   path: '/bp-view',
      //   // component: () => import('@/components/bp/prepare.vue'),
      //   component: () => import('@/components/bp/bpView.vue'),
      //   meta: {
      //     title: 'BP模拟器-准备',
      //   },
      // },
      {
        path: '/sandTable',
        component: () => import('@/components/sandTable/index.vue'),
        meta: {
          title: '沙盘工具',
        },
      },
      // {
      //   path: '/player',
      //   component: () => import('@/components/player/Player.vue'),
      //   meta: {
      //     title: '选手数据',
      //   },
      // },
      {
        path: '/match-player-info',
        component: () => import('@/components/player/PlayerInfo.vue'),
        meta: {
          title: '选手数据-详情',
        },
      },
      {
        path: '/match-player-honor',
        component: () => import('@/components/player/PlayerHonor.vue'),
        meta: {
          title: '选手-荣誉数据',
        },
      },
      // {
      //   path: '/team',
      //   component: () => import('@/components/team/Team.vue'),
      //   meta: {
      //     title: '战队数据',
      //   },
      // },
      {
        path: '/team-info',
        component: () => import('@/components/team/TeamInfo.vue'),
        meta: {
          title: '战队数据-详情',
        },
      },
      // {
      //   path: '/hero',
      //   component: () => import('@/components/hero/Hero.vue'),
      //   meta: {
      //     title: '英雄数据',
      //   },
      // },
      {
        path: '/hero-info',
        component: () => import('@/components/hero/HeroInfo.vue'),
        meta: {
          title: '英雄数据-详情',
        },
      },
      {
        path: '/zone',
        component: () => import('@/components/zone/Zone.vue'),
        meta: {
          title: '赛区',
        },
      },
      {
        path: '/match-list',
        component: () => import('@/components/match/Match.vue'),
        meta: {
          title: '赛事',
        },
      },
      {
        path: '/match',
        component: () => import('@/components/match/Index.vue'),
        meta: {
          title: '赛事',
        },
      },
      {
        path: '/match-info',
        // component: () => import('@/components/match/MatchInfo.vue'),
        component: () => import('@/components/match/NewMatchInfo.vue'),
        meta: {
          title: '赛事',
        },
      },
      {
        path: '/match-finals-list',
        // component: () => import('@/components/match/finals/container/FinalsList.vue'),
        component: () => import('@/components/match/finals/container/MatchList.vue'),
        meta: {
          title: '全国大赛',
        },
      },
      {
        path: '/match-finals-single',
        component: () => import('@/components/match/finalsSingle/container/FinalsSingle.vue'),
        meta: {
          title: '决赛赛程',
        },
      },
      {
        path: '/personnel',
        component: () => import('@/components/personnel/NewPersonnel.vue'),
        meta: {
          title: '电竞人才',
        },
      },
      {
        path: '/personnel-info',
        component: () => import('@/components/personnel/NewPersonnelInfo.vue'),
        meta: {
          title: '电竞人才-详情',
        },
      },
    ],
  },
]

const router = new Router({
  mode: 'history',
  // base: '/',
  routes: routes
})

router.beforeEach((to, from, next) => {

  if (to.meta) {
    if (to.meta.title) {
      document.title = to.meta.title
    } else {
      document.title = 'PentaQ《王者荣耀》全国大赛数据平台'
    }
  } else {
    document.title = 'PentaQ《王者荣耀》全国大赛数据平台'
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js